import { MenuItem, styled } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useCulturesQuery } from '@Store/api/translationsSlice';
import { useTranslation } from 'providers/CultureProvider';

const StyledSelect = styled(Select)`
  color: #fff;
  width: 100%;

  .MuiSelect-icon {
    color: #fff;
  }

  fieldset {
    border-color: rgba(255, 255, 255, 0.3);
  }

  &:hover fieldset {
    border-color: rgba(255, 255, 255, 0.6);
  }
`;

export function CultureSwitcher() {
  const { culture, setCulture } = useTranslation();
  const { data: cultures } = useCulturesQuery();

  const activeCultures = (cultures ?? []).filter((c) => c.isActive);

  if (!activeCultures.length) {
    return null;
  }

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    setCulture(event.target.value as string);
  };

  return (
    <StyledSelect size='small' value={culture} onChange={handleChange}>
      {activeCultures.map((c) => (
        <MenuItem key={c.cultureCode} value={c.cultureCode}>
          {c.displayName}
        </MenuItem>
      ))}
    </StyledSelect>
  );
}
